import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";
import { RadioButtonGroup } from "@circle-react-shared/RadioButtonGroup";
import type { RecurringEditMode } from "../helpers/constants";
import { RECURRING_EDIT_MODE } from "../helpers/constants";

const translationRoot = "events.delete.recurring_event_modal";

interface DeleteRecurringModalProps {
  isDeleting?: boolean;
  onCloseModal: () => void;
  onConfirm: (frequency: RecurringEditMode) => void;
  show?: boolean;
}

export const DeleteRecurringModal = ({
  show = false,
  onConfirm,
  onCloseModal,
  isDeleting = false,
}: DeleteRecurringModalProps) => {
  const [selectedFrequency, setSelectedFrequency] =
    useState<RecurringEditMode>();

  const onRadioChangeHandler = (value: RecurringEditMode) => {
    setSelectedFrequency(value);
  };

  const onConfirmHandler = () => {
    if (selectedFrequency) {
      onConfirm(selectedFrequency);
    }
  };

  return (
    <ConfirmationModal
      title={t(`${translationRoot}.title`)}
      isOpen={show}
      confirmText={isDeleting ? t("deleting") : t(`${translationRoot}.accept`)}
      cancelText={t(`${translationRoot}.cancel`)}
      onClose={onCloseModal}
      onCancel={onCloseModal}
      onConfirm={onConfirmHandler}
      disabled={isDeleting}
      confirmVariant="danger"
      size="sm"
    >
      <div className="mt-6">
        <RadioButtonGroup
          defaultChecked={RECURRING_EDIT_MODE.CURRENT}
          name="recurring_event_settings.frequency_edit"
          options={[
            {
              label: t(`${translationRoot}.this_event`),
              value: RECURRING_EDIT_MODE.CURRENT,
            },
            {
              label: t(`${translationRoot}.this_and_following`),
              value: RECURRING_EDIT_MODE.REMAINING,
            },
            {
              label: t(`${translationRoot}.all_events`),
              value: RECURRING_EDIT_MODE.ALL,
            },
          ]}
          size="sm"
          onChange={onRadioChangeHandler}
        />
      </div>
    </ConfirmationModal>
  );
};
